// Client-side thumbnail-generatie voor support-screenshots.
// Tekent de afbeelding verkleind (max breedte) op een canvas en exporteert als
// JPEG. Geeft { thumbnailBlob, thumbnailBase64 } terug (base64 zonder data:-prefix),
// of null bij een fout (stil — een mislukte thumbnail mag het indienen niet breken).

function _lees(file, alsDataUrl = true) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = () => resolve(reader.result)
    reader.onerror = reject
    if (alsDataUrl) reader.readAsDataURL(file)
    else reader.readAsArrayBuffer(file)
  })
}

export async function maakThumbnail(file, maxBreedte = 300, kwaliteit = 0.6) {
  try {
    const dataUrl = await _lees(file)
    const img = await new Promise((resolve, reject) => {
      const i = new Image()
      i.onload = () => resolve(i)
      i.onerror = reject
      i.src = dataUrl
    })

    const schaal = Math.min(1, maxBreedte / (img.width || maxBreedte))
    const breedte = Math.max(1, Math.round(img.width * schaal))
    const hoogte = Math.max(1, Math.round(img.height * schaal))

    const canvas = document.createElement('canvas')
    canvas.width = breedte
    canvas.height = hoogte
    canvas.getContext('2d').drawImage(img, 0, 0, breedte, hoogte)

    const blob = await new Promise((resolve) => canvas.toBlob(resolve, 'image/jpeg', kwaliteit))
    if (!blob) return null

    const blobDataUrl = await _lees(blob)
    const base64 = String(blobDataUrl).slice(String(blobDataUrl).indexOf(',') + 1)
    return { thumbnailBlob: blob, thumbnailBase64: base64 }
  } catch {
    return null
  }
}
